

































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Ingredient } from '@/api';

import RelAutocompleteAsync from '@/components/common/RelAutocompleteAsync.vue';

@Component({ components: { RelAutocompleteAsync } })
export default class LibrarySelect extends Vue {
  @Prop({ required: true }) readonly recipeId: string;

  @Prop({ type: Boolean, default: false }) readonly readonly: boolean;

  ingredient: Ingredient | null = null;

  get scopeFactory() {
    return () =>
      Ingredient.where({
        for_recipe: this.recipeId,
        shared: true,
        is_archived: false,
      });
  }

  itemSelected(item: Ingredient) {
    this.$emit('select', item);
    this.$nextTick(() => {
      this.ingredient = null;
    });
  }
}
